import {
    ChangeDetectorRef,
    Component,
    ContentChildren,
    ElementRef, EventEmitter,
    HostBinding,
    HostListener,
    Input, OnDestroy, Output,
    QueryList
} from "@angular/core";
import {FUICommandComponent} from "./command/command.component";
import {Subscription} from "rxjs";
import {PopParentHorizontalAlignment} from "../pops/abstract-pop";
import {FUIEventsService} from "../events/events.service";

@Component({
    selector: "fui-commands",
    styleUrls: ["./commands.component.scss"],
    templateUrl: "./commands.component.html"
})
export class FUICommandsComponent implements OnDestroy {
    @ContentChildren(FUICommandComponent) public commands: QueryList<FUICommandComponent>;
    @Input() public title: string;
    @Input() public icon: string;
    @Input() public iconSize: number = 16;
    @Input() showPopupForSingleItems: boolean = false;
    @Input() popAlignment: PopParentHorizontalAlignment = PopParentHorizontalAlignment.LEFT;
    @Output() public toggled$: EventEmitter<boolean>;
    public toggled: boolean;
    private _$click: Subscription;

    constructor(private elementRef: ElementRef,
                private eventsService: FUIEventsService,
                protected changeDetectorRef: ChangeDetectorRef) {
        this.toggled$ = new EventEmitter<boolean>();
    }

    get hasCommands(): boolean {
        return this.showPopupForSingleItems ? this.commands.length > 0 : this.commands.length > 1;
    }

    @HostBinding("class.disabled")
    get isDisabled(): boolean {
        return !this.commands.some(command => !command.disabled);
    }

    ngOnInit(): void {
        this._$click = this.eventsService.click$.subscribe(
            (click) => {
                if (this.toggled && !this.elementRef.nativeElement.contains(click.target)) {
                    this.toggled = false;
                    this.toggled$.emit(this.toggled);
                    this.changeDetectorRef.detectChanges();
                }
            }
        )
    }

    @HostListener("click")
    public click(): void {
        if (this.hasCommands) {
            this.toggle();
        } else {
            this.commands.first.click();
        }
    }

    popped(popped: boolean) {
        this.toggled = popped;
        this.toggled$.emit(this.toggled);
    }

    /**
     *
     */
    public toggle(): void {
        this.toggled = !this.toggled;
        this.toggled$.emit(this.toggled);
    }

    ngOnDestroy(): void {
        if (this._$click) {
            this._$click.unsubscribe();
        }
    }
}
